import PropTypes from 'prop-types';
import React, {
  memo, useCallback, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { FaRegQuestionCircle } from 'react-icons/fa';
import RatingHotelFilter from './RatingHotelFilter';
import CheckInDateFilter from './CheckInDateFilter';
import CheckOutDateFilter from './CheckOutDateFilter';
import HotelNameFilter from './HotelNameFilter';
import AgentPreferencesFilter from './AgentPreferencesFilter';
import HotelsSearch from './HotelsSearch';
import RateCodePreferencesFilter from './RateCodePreferencesFilter';
import HotelChainsFilter from './HotelChainsFilter';
import HotelPriceFilter from './HotelPriceFilter';
import PricePreferenceFilter from './PricePreferenceFilter';
import HotelAmenitiesFilter from './HotelAmenitiesFilter';
import RateCodeKeys from './RateCodeKey';
import { SearchModes } from '../../../../constants';
import HotelRadiusFilter from './HotelRadiusFilter';

const HotelFilterBar = ({ tripId, defaultSearchLocationName }) => {
  const [doOpenFirstDatePicker, setDoOpenFirstDatePicker] = useState(false);
  const [doOpenSecondDatePicker, setDoOpenSecondDatePicker] = useState(false);
  const { selectedSearchMode } = useSelector((store) => store.tripSearch);

  const handleOpenFirstDatePicker = useCallback((val) => {
    setDoOpenFirstDatePicker(val);
    if (!val) {
      setTimeout(() => { setDoOpenSecondDatePicker(true); }, 50);
    }
  }, []);

  useEffect(() => {
    if (doOpenFirstDatePicker) setDoOpenSecondDatePicker(false);
  }, [doOpenFirstDatePicker]);

  return (
    <div className={clsx('flex flex-wrap gap-2 text-theme border-b-2 pb-2')}>
      <HotelsSearch tripId={tripId} defaultSearchLocationName={defaultSearchLocationName} />
      <CheckInDateFilter
        tripId={tripId}
        doOpenDatePicker={doOpenFirstDatePicker}
        setDoOpenDatePicker={handleOpenFirstDatePicker}
      />
      <CheckOutDateFilter
        tripId={tripId}
        doOpenDatePicker={doOpenSecondDatePicker}
        setDoOpenDatePicker={setDoOpenSecondDatePicker}
      />
      <RatingHotelFilter tripId={tripId} />
      <HotelAmenitiesFilter tripId={tripId} />
      <HotelNameFilter tripId={tripId} />
      <AgentPreferencesFilter tripId={tripId} />
      <RateCodePreferencesFilter tripId={tripId} />
      <HotelChainsFilter tripId={tripId} />
      <HotelPriceFilter tripId={tripId} variant={null} />
      <PricePreferenceFilter tripId={tripId} />
      <RateCodeKeys filterSpacingClass="py-3 px-3" icon={<FaRegQuestionCircle className="text-green-600 min-w-4 place-self-center mr-1" size={20} />} selectedSearchMode={SearchModes.HOTEL} dropdownAligning={selectedSearchMode !== SearchModes.HOTEL ? 'right' : 'left'} />
      <HotelRadiusFilter tripId={tripId} />
    </div>
  );
};

HotelFilterBar.propTypes = {
  tripId: PropTypes.string.isRequired,
  defaultSearchLocationName: PropTypes.string,
};

HotelFilterBar.defaultProps = {
  defaultSearchLocationName: null,
};

export default memo(HotelFilterBar);
